import { render, staticRenderFns } from "./UserProfileCardAlternative.vue?vue&type=template&id=40470508&scoped=true&"
import script from "./UserProfileCardAlternative.vue?vue&type=script&lang=js&"
export * from "./UserProfileCardAlternative.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileCardAlternative.vue?vue&type=style&index=0&id=40470508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40470508",
  null
  
)

export default component.exports